<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction>
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="uploadButtonClicked()">
              <i class="fas fa-upload mr-2"></i>Upload
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>Cancel
            </button>
          </div>
        </template>
      </PageHeaderNoAction>

      <div class="section-body">
        <DataFilter :gridId="gridId" :isExport="false"></DataFilter>
        <FileUpload
          id="uploadPaid"
          title="Paid File:"
          v-model="file"
          :multiple="false"
          :readonly="false"
          :required="false"
          :fileFormat="['xls','xlsx']"
          labelwidth="2"
        />
        <SlickGrid
          :gridId="gridId"
          :editable="false"
          :frozenColumn="2"
          :isAutoInitData="true"
          baseUrl="/paid_file"
        />
      </div>
    </section>



    <!-- Upload modal -->
    <!--<div id="uploadDialog" class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="Uploader">
              <span>Your browser doesn't support native upload.</span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary legitRipple" @click="uploadButtonClicked()">
              <i class="icon-floppy-disk mr-2"></i>Upload
            </button>
          </div>
        </div>
      </div>
    </div>-->
    <!-- /Upload modal -->

  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "Upload Paid File",
  access_code: "L_FORM02",
  icon: "fas fa-university",
  components: {},
  data() {
    return {
      gridId: "up01",
      file: [],
      formData: {
        staff_name: ""
      }
    };
  },
  created() {
    ////this.$route.meta.access_code = this.gridId;
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    },
    mode() {
      return this.grid.mode;
    },
    dataList() {
      return this.grid.selectRows;
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest"
    ]),


    uploadButtonClicked() {
      if (this.file.length == []) {
        helper.alert("Please select file to upload");
        return;
      }
      helper.loading();
      // let copyForm = _.cloneDeep(this.formData);
      // helper.join(copyForm, "declare");
        var postData = new FormData()
        postData.append('SessionID', helper.getSessionID())
        postData.append('LocaleCode', helper.getLocaleCode())
        var fileParams = [];
        // fileParams.push({
        //     this.file
        //   });


          console.log(this.file);
          $.each(this.file, function(i, f) {
          postData.append("Files", f.file);
          fileParams.push({
            id: i,
            field: f.field,
            action: f.action,
            refId: "f" + i,
            
          });
        });
         console.log(fileParams);
        postData.append('FileParams', JSON.stringify(fileParams));
      api.request(
        this,
        "post",
        `/paid_file/${this.gridId}_upload`,
        // {
        //   SessionID: helper.getSessionID(),
        //   LocaleCode: helper.getLocaleCode(),
        //   //LocaleCode: this.$store.state.user.locale_code,
        //   Parameters: {
        //     file: this.file
        //   }
        // },
        postData,
        function(r) {
          helper.clearData(this);
          helper.findNow(this);
          helper.done();
        },
        function(r) {
          helper.done();
        },
        null
      );
    },

    cancelBtnClick() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.section-body {
  padding-top: 100px;
}
</style>